var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeSupporter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_43606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0.25C14.5131 0.25 15.75 1.48693 15.75 3V13C15.75 14.5131 14.5131 15.75 13 15.75H3C1.48693 15.75 0.25 14.5131 0.25 13V3C0.25 1.48693 1.48693 0.25 3 0.25H13Z",
    fill: "url(#paint0_linear_295_43606)",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.425C14.25 12.575 13.325 13.5 12.175 13.5H3.825C2.675 13.5 1.75 12.575 1.75 11.425V3.075C1.75 1.925 2.675 1 3.825 1H12.15C13.3 1 14.225 1.925 14.225 3.075V11.425H14.25Z",
    fill: "url(#paint1_linear_295_43606)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02148 3.59009C8.55811 3.59019 8.99308 4.02499 8.99316 4.56177V5.56665L9.86328 5.0647C10.3281 4.79634 10.9229 4.95514 11.1914 5.42017C11.4597 5.88524 11.2995 6.47907 10.835 6.74731L9.96387 7.24927L10.835 7.7522C11.2996 8.02047 11.4599 8.61521 11.1914 9.08032C10.9229 9.54519 10.328 9.704 9.86328 9.43579L8.99316 8.93188V9.93774C8.99316 10.4746 8.55816 10.9103 8.02148 10.9104C7.48468 10.9104 7.0498 10.4746 7.0498 9.93774V8.93286L6.17969 9.43579C5.71484 9.70418 5.12003 9.54516 4.85156 9.08032C4.58322 8.61555 4.74237 8.02072 5.20703 7.7522H5.20801L6.07715 7.24927L5.20801 6.74731H5.20703C4.74263 6.47878 4.58349 5.88483 4.85156 5.42017C5.12001 4.95528 5.71482 4.7963 6.17969 5.0647L7.0498 5.56665V4.56177C7.04988 4.02503 7.48473 3.59012 8.02148 3.59009Z",
    fill: "white",
    stroke: "#39379F",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_295_43606",
    x1: 2.5,
    y1: 16,
    x2: 15,
    y2: -1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6461FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_295_43606",
    x1: 7,
    y1: 7.5,
    x2: 15,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B58FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5551FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_43606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeSupporter);
export default __webpack_public_path__ + "static/media/badge-supporter.d2ccdc14e9b535b0b9d8683a7b80785e.svg";
export { ForwardRef as ReactComponent };